<template>
  <div class="page-container">
    <Table
      ref="tableRef"
      :params="params"
      :request="searchData"
      tooltip-effect="light"
    >
      <template #search>
        <el-form-item>
          <el-button v-show="authList.includes('healthTask:add')" type="primary" icon="el-icon-plus" @click="addNew"
            >{{$t('elp.filter.add')}}</el-button
          >
        </el-form-item>
      </template>
      <template #toolBar>
        <el-input-number
          v-model="duration"
          controls-position="right"
          :disabled="realTime"
          :min="1"
          size="small"
          style="margin-right: 10px"
        />
        <el-switch
          v-model="realTime"
          :active-text="$t('collect.tasklist.realTimeUpdate')"
          @change="onRealTimeChange"
        />
      </template>
      <el-table-column prop="taskName" :label="$t('collect.messagelist.taskName')" >
        <template #default="scope">
          <a style="color: var(--el-color-primary);cursor: pointer;" @click="editInfo(scope.row)">{{ scope.row.taskName }}</a>
        </template>
      </el-table-column>
      <el-table-column v-if="userInfo.internalUser" prop="taskId" :label="$t('collect.tasklist.taskNumber')" />
      <el-table-column prop="robotSN" :label="$t('activity.packetjoin.robotCode')" />
      <el-table-column prop="cabinetSN" :label="$t('equipment.cabinet.ctrlCode')">
        <template #default="scope">
          <span v-if="scope.row.cabinetSN?.length > 4 && ![undifined, 'undifined', 'Invalid-ID'].includes(scope.row.cabinetSN)">{{scope.row.cabinetSN}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="400"
            trigger="hover"
            title=""
          >
            <template #default>
              <el-descriptions title="" column="1" border>
                <el-descriptions-item :label="$t('error.alarm.reportinformation')">{{scope.row.cabinetSN}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.solution')">{{$t('error.alarm.solutionInfo')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method1')">{{$t('error.alarm.methodInfo1')}}</el-descriptions-item>
                <el-descriptions-item :label="$t('error.alarm.method2')">{{$t('error.alarm.methodInfo2')}}</el-descriptions-item>
              </el-descriptions>
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{ $t('error.alarm.pendingReport') }}
                <i class="el-icon-warning" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="runDays" :label="$t('collect.tasklist.taskRunDays')" />
      <el-table-column prop="runTimesPerDay" :label="$t('collect.tasklist.collectionsPerDay')" />
      <el-table-column prop="maxRecordTime" :label="$t('collect.tasklist.singleCollectionDuration')" />
      <el-table-column prop="minTimeInterval" :label="$t('collect.tasklist.minRunInterval')" />
      <el-table-column prop="programNameFilter" :label="$t('collect.tasklist.programFilter')" />
      <!-- <el-table-column prop="reportCollectStatus" :label="$t('collect.tasklist.collectionStatus')" /> -->
      <el-table-column prop="reportCollectStatus" :label="$t('collect.tasklist.collectionStatus')">
        <template #default="scope">
          <span v-if="scope.row.reportCollectStatus == '上传成功' || scope.row.reportCollectStatus == '已结束'">{{taskField.find(type => type.value === scope.row.reportCollectStatus)?.label}}</span>
          <el-popover
            v-else
            placement="top-start"
            :width="200"
            trigger="hover"
            :title= "taskSubField.find(type => type.value === scope.row.subStatusName)?.label"
          >
            <template #default>
              {{scope.row.message}}
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{taskField.find(type => type.value === scope.row.reportCollectStatus)?.label}}
                <i class="el-icon-question" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="statusName" :label="$t('collect.tasklist.taskStatus')">
        <template #default="scope">
          <span v-if="scope.row.statusName == '已结束'">{{taskField.find(type => type.value === scope.row.statusName)?.label}}</span>
          <el-popover
           v-else
            placement="top-start"
            :width="200"
            trigger="hover"
            :title= "taskSubField.find(type => type.value === scope.row.subStatusName)?.label"
          >
            <template #default>
              {{scope.row.message}}
            </template>
            <template #reference>
              <span style="cursor: pointer;">
                {{taskField.find(type => type.value === scope.row.statusName)?.label}}
                <i class="el-icon-question" style="margin-left: 6px;color: #E6A23C;"></i>
              </span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="statusName" :label="$t('collect.tasklist.taskStatus')" /> -->
      <el-table-column :label="$t('collect.healthscorelist.healthScore')" width="100">
        <template #default="scope">
          <el-progress
            type="circle"
            :percentage="scope.row.score"
            class="progress-text"
            :color="scope.row.color"
            width="60"
          ></el-progress>
        </template>
      </el-table-column>
      <el-table-column prop="createBy" :label="$t('activity.list.creator')"/>
      <el-table-column prop="createTime" :label="$t('activity.list.createTime')" />
      <el-table-column :label="$t('activity.list.operation')" width="150" fixed="right">
        <template #default="{ row }">
          <el-button
            v-show="authList.includes('healthTask:terminate')"
            v-if="row.statusName == '执行中'"
            @click="terminateTask(row)"
            type="text"
            size="small"
            >{{$t('collect.tasklist.earlyTermination')}}</el-button
          >
          <el-button
            v-show="authList.includes('healthTask:record')"
            @click="jumpReport(row)"
            type="text"
            size="small"
            >{{$t('collect.tasklist.msgManagement')}}</el-button
          >
        </template>
      </el-table-column>
    </Table>
    <el-dialog
      :title="$t('collect.tasklist.addNewTask')"
      top="5vh"
      v-model="dialogFormVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
      width="65%"
    >
      <el-form
        ref="detailformRef"
        class="dialog-form"
        :model="detailform"
        :rules="detailformRules"
        :label-width="curLang == 'en-US' ? '330px' : '240px'"
      >
        <el-form-item :label="$t('collect.messagelist.taskName')" prop="taskName">
          <el-input
            v-model="detailform.taskName"
            :placeholder="$t('collect.messagelist.taskName')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('collect.tasklist.selectTemplate')" prop="taskTemplateId">
          <el-select v-model="detailform.taskTemplateId" :placeholder="$t('collect.tasklist.selectTemplate')" clearable filterable @change="onTemplateChange">
            <el-option
              v-for="item in taskTemplateList"
              :key="item.id"
              :label="item.templateName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-tag v-if="detailform.taskTemplateId" style="margin-left: 24px;" type="danger">{{templateType?.[detailform.templateType]}}</el-tag>
        </el-form-item>

        <!-- <el-form-item :label="$t('collect.taskTemplates.taskType')" prop="templateType">
          <el-radio-group disabled="true" v-model="detailform.templateType">
            <el-radio :label="2">手动添加</el-radio>
            <el-radio :label="0">{{$t('collect.taskTemplates.universalTemplate')}}</el-radio>
            <el-radio :label="1">{{$t('collect.taskTemplates.modelSpecific')}}</el-radio>
          </el-radio-group>
        </el-form-item> -->
        <el-form-item :label="$t('collect.tasklist.taskRunDaysUnit')" prop="runDays">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.runDays"
            :placeholder="$t('collect.tasklist.taskRunDaysRange')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('collect.tasklist.executionsPerDayUnit')" prop="runTimesPerDay">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.runTimesPerDay"
            :placeholder="$t('collect.tasklist.executionsPerDayRange')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('collect.tasklist.maxRunTimeUnit')" prop="maxRecordTime">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.maxRecordTime"
            :placeholder="$t('collect.tasklist.maxRunTimeRange')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('collect.tasklist.minRunIntervalUnit')" prop="minTimeInterval">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.minTimeInterval"
            :placeholder="$t('collect.tasklist.minRunIntervalRange')"
            clearable
          />
        </el-form-item>
        <el-form-item :label="$t('collect.tasklist.programFilterMethod')" prop="isMatchProgramAccurately">
          <el-radio-group :disabled="detailform.templateType !== 2" v-model="detailform.isMatchProgramAccurately">
            <el-radio v-if="detailform.templateType !== 1" :label="-1">{{$t('collect.tasklist.mismatch')}}</el-radio>
            <el-radio :label="1">{{$t('collect.tasklist.exactMatch')}}</el-radio>
            <el-radio :label="0">{{$t('collect.tasklist.fuzzyMatch')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="detailform.templateType !== 1 && detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.programFilter')" prop="programNameFilter">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.programNameFilter"
            :placeholder="$t('collect.tasklist.programFilter')"
            clearable
          />
        </el-form-item>
        <el-form-item v-if="detailform.templateType !== 1 && detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.maxCollectionsPerProgram')" prop="singleProgramRecordTime">
          <el-input
            :disabled="detailform.templateType !== 2"
            v-model="detailform.singleProgramRecordTime"
            :placeholder="$t('collect.tasklist.maxCollectionsPerProgramRange')"
            clearable
          />
        </el-form-item>
      </el-form>
      <el-button style="margin-top: 12px;" size="small" type="primary" @click="addRobot">{{$t('collect.tasklist.add')}}</el-button>
      <el-table :data="robotDataList" height="300px">
        <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
        <el-table-column v-if="detailform.templateType !== 2" prop="queryRobotModel" :label="$t('collect.tasklist.model')">
          <template #default="scope">
            {{ parallelTaskTemplate[scope.row.robotId]?.robotModel }}
          </template>
        </el-table-column>
        <el-table-column v-if="detailform.templateType == 1" prop="isMatchProgramAccurately" :label="$t('collect.tasklist.programMatching')">
          <template #default="scope">
            <el-tag v-if="detailform.filterList?.some(it => it.robotModel === parallelTaskTemplate[scope.row.robotId]?.robotModel)" type="success">
              {{$t('collect.tasklist.matched')}}
            </el-tag>
            <el-tag v-else type="danger"> {{$t('collect.tasklist.notMatched')}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="detailform.templateType == 1" width="150" prop="programNameFilter" :label="$t('collect.tasklist.programFilter')">
          <template #default="scope">
            {{ detailform.filterList?.filter(it=> it.robotModel == parallelTaskTemplate[scope.row.robotId]?.robotModel)[0]?.programName }}
          </template>
        </el-table-column>
        <el-table-column v-if="detailform.templateType == 1"  width="200" prop="singleProgramRecordTime" :label="$t('collect.tasklist.maxCollectionsPerProgram')">
          <template #default="scope">
            {{ detailform.filterList?.filter(it=> it.robotModel == parallelTaskTemplate[scope.row.robotId]?.robotModel)[0]?.runTimes }}
          </template>
        </el-table-column>
        <el-table-column v-if="detailform.templateType !== 2" prop="parallelTaskTemplateId" :label="$t('collect.tasklist.parallelTaskTemplate')">
          <template #default="scope">
            <el-select v-model="scope.row.parallelTaskTemplateId" :placeholder="$t('collect.tasklist.parallelTaskTemplate')" clearable>
              <el-option
                v-for="item in parallelTaskTemplate[scope.row.robotId]?.templateList"
                :key="item.id"
                :label="item.templateName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column v-if="userInfo.internalUser && !standard" prop="testCode" :label="$t('collect.tasklist.testOrderNumber')">
          <template #default="scope">
            <el-input
              v-model="scope.row.testCode"
              :placeholder="$t('collect.tasklist.testOrderNumber')"
              clearable
            />
          </template>
        </el-table-column>
        <el-table-column prop="cabinetId" :label="$t('collect.healthscorelist.ctrlCabCode')" />
        <el-table-column :label="$t('collect.tasklist.robotStatus')">
          <template #default="scope">
            {{ statusList[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('activity.list.operation')" width="100" fixed="right">
          <template #default="{ row }">
            <i class="el-icon-delete" @click="deleteRobot(row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <template #footer>
        <el-button size="small" type="primary" @click="editSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
    </el-dialog>
    <el-dialog
      :title="$t('collect.tasklist.taskDetails')"
      top="5vh"
      v-model="dialogDetialVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
    >
      <el-descriptions title="" column="2" direction="vertical" border>
        <el-descriptions-item :label="$t('collect.tasklist.selectTemplate')">{{taskTemplateList.filter(it=>it.id == detailform.taskTemplateId)[0]?.templateName}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.taskTemplates.taskType')">{{templateType[detailform.templateType]}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.messagelist.taskName')">{{detailform.taskName}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.taskNumber')">{{detailform.taskId}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.packetjoin.robotCode')">{{ detailform.robotSN }}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.healthscorelist.ctrlCabCode')">{{detailform.cabinetSN}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.taskRunDaysUnit')">{{detailform.runDays}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.executionsPerDayUnit')">{{detailform.runTimesPerDay}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.maxRunTimeUnit')">{{detailform.maxRecordTime}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.minRunIntervalUnit')">{{ detailform.minTimeInterval }}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.programFilterMethod')">{{ detailform.isMatchProgramAccurately ? $t('collect.tasklist.exactMatch') : detailform.programNameFilter ? $t('collect.tasklist.fuzzyMatch') : $t('collect.tasklist.mismatch')}}</el-descriptions-item>
        <el-descriptions-item v-if="detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.programFilter')">{{detailform.programNameFilter}}</el-descriptions-item>
        <el-descriptions-item v-if="detailform.isMatchProgramAccurately !== -1" :label="$t('collect.tasklist.maxCollectionsPerProgram')">{{detailform.singleProgramRecordTime}}</el-descriptions-item>
        <el-descriptions-item :label="$t('collect.tasklist.collectionStatus')">{{ taskField.find(type => type.value === detailform.reportCollectStatus)?.label}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.list.creator')">{{detailform.createBy}}</el-descriptions-item>
        <el-descriptions-item :label="$t('activity.list.createTime')">{{detailform.createTime}}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>
    <el-dialog
      :title="$t('collect.tasklist.selectRobot')"
      top="5vh"
      v-model="dialogTableVisible"
      destroy-on-close
      :modal="true"
      :append-to-body="true"
    >
      <Filter
        ref="filterRef"
        :params="tableParams"
        @search="searchRobotData"
      ></Filter>
      <el-table
        ref="multipleTable"
        :data="tableRobotDataList"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" :selectable="selectable" width="55">
        </el-table-column>
        <el-table-column prop="robotId" :label="$t('activity.packetjoin.robotCode')" />
        <el-table-column prop="cabinetId" :label="$t('collect.healthscorelist.ctrlCabCode')" />
        <el-table-column :label="$t('collect.tasklist.robotStatus')">
          <template #default="scope">
            {{ statusList[scope.row.status] }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 50, 200, 500]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="robotTotal"
      >
      </el-pagination>
      <template #footer>
        <el-button size="small" type="primary" @click="selectSubmit"
          >{{$t('activity.list.confirm')}}</el-button
        >
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { request } from '@/utils/request'
import { common } from '../../common/mixin'
// import Table from '@/components/table/index'
import Table from '@/components/elp/table'
import Filter from '@/components/table/filter'
import dayjs from 'dayjs'
import { reactive, toRefs } from '@vue/reactivity'
import { ElMessageBox, ElMessage } from 'element-plus'
import { robotStatusMap } from '../../common/constant'
import { intValidator, } from '../../common/utils'

import { reqCollectTaskList } from '@/api/upgrade'
import { useRouter } from 'vue-router'
import { standard } from '@/common/constant';
import { useI18n } from 'vue-i18n'
import { computed } from "vue";
import { useStore } from "vuex"
export default {
  components: {
    Table,
    Filter
  },
  mixins: [common],
  setup () {
    const store = useStore()
    const { t } = useI18n()
    const router = useRouter()
    const userInfo = window.localStorage.getItem('userInfo')

    const taskFields = [
      {
        label: t('collect.tasklist.inProgress'),
        value: "执行中"
      },
      {
        label: t('activity.detail.ended'),
        value: "已结束"
      },
      {
        label: t('collect.tasklist.terminated'),
        value: "已终止"
      },
      {
        label: t('collect.tasklist.creationFailed'),
        value: "创建失败"
      },
      {
        label: t('collect.tasklist.uploadSuccess'),
        value: "上传成功"
      },
      {
        label: t('collect.tasklist.uploadFailed'),
        value: "上传失败"
      },
      {
        label: t('collect.tasklist.executionFailed'),
        value: "执行失败"
      },
      {
        label: t('collect.tasklist.deleting'),
        value: "删除中"
      },
      {
        label: t('collect.tasklist.deleteFailed'),
        value: "删除失败"
      }
    ]
    const taskSubFields = [
      {
        label: t('collect.tasklist.creationSuccess'),
        value: "创建成功",
        key: 1
      },
      {
        label: t('collect.tasklist.creationFailed'),
        value: "创建失败",
        key: 2
      },
      {
        label: t('collect.tasklist.pushDownSuccess'),
        value: "下推成功",
        key: 3
      },
      {
        label: t('collect.tasklist.pushDownFailed'),
        value: "下推失败",
        key: 4
      },
      {
        label: t('collect.tasklist.taskAccepted'),
        value: "接受任务",
        key: 5
      },
      {
        label: t('collect.tasklist.taskRejected'),
        value: "拒绝任务",
        key: 6
      },
      {
        label: t('collect.tasklist.waitingForCollection'),
        value: "等待采集",
        key: 7
      },
      {
        label: t('collect.tasklist.collecting'),
        value: "采集中",
        key: 8
      },
      {
        label: t('collect.tasklist.collectionSuccess'),
        value: "采集成功",
        key: 9
      },
      {
        label: t('collect.tasklist.collectionFailed'),
        value: "采集失败",
        key: 10
      },
       {
        label: t('collect.tasklist.uploadSuccess'),
        value: "上传成功",
        key: 11
      },
      {
        label: t('collect.tasklist.uploadFailed'),
        value: "上传失败",
        key: 12
      },
       {
        label: t('collect.tasklist.parsingSuccess'),
        value: "解析成功",
        key: 13
      },
      {
        label: t('collect.tasklist.parsingFailed'),
        value: "解析失败",
        key: 14
      },
      {
        label: t('collect.tasklist.predictionSuccess'),
        value: "预测成功",
        key: 15
      },
      {
        label: t('collect.tasklist.predictionFailed'),
        value: "预测失败",
        key: 16
      },
      {
        label: t('collect.tasklist.deleteSuccess'),
        value: "删除成功",
        key: 17
      },
      {
        label: t('collect.tasklist.deleting'),
        value: "删除中",
        key: 18
      },
      {
        label: t('collect.tasklist.deleteFailed'),
        value: "删除失败",
        key: 19
      }
    ]
    const state = reactive({
      realTime: false, // 是否实时更新
      timer: null, // 定时器
      duration: 10, // 时长
      tableRef: null,
      query: {
        otaUpgradeTimeRange: [
          dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
          dayjs().format('YYYY-MM-DD') + ' 23:59:59'
        ]
      },
      queryRobot: {},
      page: 1,
      size: 10,
      total: 0,
      robotTotal: 0,
      dialogFormVisible: false,
      dialogDetialVisible: false,
      dialogTableVisible: false,
      tableDataList: [],
      robotDataList: [],
      tableRobotDataList: [],
      detailformRef: null,
      detailform: {
        taskName: '',
        runDays: '',
        runTimesPerDay: '',
        maxRecordTime: '',
        minTimeInterval: '',
        programNameFilter: '',
        isMatchProgramAccurately: -1,
        singleProgramRecordTime: 0,
        reportCollectStatus: null,
        cabinetSN: '',
        createBy: '',
        createTime: '',
        robotSN: '',
        taskId: '',
        robotList: [],
        templateType: '',
        taskTemplateId: ''
      },
      params: [
        {
          key: 'robotSN',
          value: '',
          label: t('activity.packetjoin.robotCode')
        },
        {
          key: 'cabinetSN',
          value: '',
          label: t('collect.healthscorelist.ctrlCabCode')
        },
        {
          type: 'Select',
          key: 'reportCollectStatus',
          value: null,
          label: t('collect.tasklist.collectionStatus'),
          options: {
            data: taskFields,
            label: 'label',
            value: 'value'
          }
        },
        {
          type: 'Select',
          key: 'statusName',
          value: null,
          label: t('collect.tasklist.taskStatus'),
          options: {
            data: taskFields,
            label: 'label',
            value: 'value'
          },
          display: true
        },
        {
          type: 'Date',
          key: 'otaUpgradeTimeRange',
          value: [
            dayjs().subtract(3, 'month').format('YYYY-MM-DD') + ' 00:00:00',
            dayjs().format('YYYY-MM-DD') + ' 23:59:59'
          ],
          label: t('collect.tasklist.operationTime'),
          options: {
            type: 'datetimerange',
            format: 'YYYY-MM-DD HH:mm:ss',
            'value-format': 'YYYY-MM-DD HH:mm:ss',
            'range-separator': t('activity.detail.to'),
            'start-placeholder': t('activity.list.startDate'),
            'end-placeholder': t('activity.list.endDate'),
            'default-time': [
              new Date(2000, 1, 1, 0, 0, 0),
              new Date(2000, 1, 1, 23, 59, 59)
            ]
          }
        }
      ],
      tableParams: [
        {
          key: 'robotId',
          value: '',
          label: t('activity.packetjoin.robotCode')
        }
      ],
      versionInfo: null,
      multipleSelection: [],
      statusList: robotStatusMap,
      toggleRowSelection: [],
      multipleTable: null,
      standard: standard,
      userInfo: userInfo ? JSON.parse(userInfo) : {},
      curLang: computed(() => store.state.lang),
      taskField: taskFields,
      taskSubField: taskSubFields,
      ifDetial: false,
      authList: JSON.parse(window.localStorage.getItem('authList')),
      taskTemplateList: [],
      parallelTaskTemplate: [],
      templateType: {
        0: t('collect.taskTemplates.universalTemplate'),
        1: t('collect.taskTemplates.modelSpecific'),
        2: t('collect.tasklist.manuallyAdded')
      }
    })
    const detailformRules = reactive({
      taskName: {
        required: true,
        message: t('collect.tasklist.enterTaskName'),
        trigger: 'change'
      },
      taskTemplateId: {
        required: true,
        message: t('collect.tasklist.selectTemplate'),
        trigger: 'change'
      },
      runDays: intValidator({
        label: t('collect.tasklist.taskRunDays'),
        min: 0,
        max: 365
      }),
      runTimesPerDay: intValidator({
        label: t('collect.tasklist.executionsPerDay'),
        min: 0,
        max: 60
      }),
      maxRecordTime: intValidator({
        label: t('collect.tasklist.maxRunTime'),
        min: 30,
        max: 150
      }),
      minTimeInterval: intValidator({
        label: t('collect.tasklist.minRunInterval'),
        min: 1,
        max: 43200
      }),
      isMatchProgramAccurately: {
        required: true,
        message: t('collect.tasklist.enterProgramFilterMethod'),
        trigger: 'change'
      },
      singleProgramRecordTime: intValidator({
        label: '',
        min: 1,
        max: 100
      }),
      programNameFilter: {
        required: true,
        message: t('collect.tasklist.programFilter'),
        trigger: 'change'
      },
    })

    const getRobotData = async () => {
      try {
        const res = await request('getCollectRobot', {
          ...state.queryRobot,
          page: state.page,
          size: state.size
        })
        state.tableRobotDataList = res.records
        state.toggleRowSelection = state.robotDataList
        state.robotDataList.map(row => {
          state.multipleTable.toggleRowSelection(
            state.tableRobotDataList.find(item => row.robotId == item.robotId),
            true
          )
        })
        state.robotTotal = res.total
      } catch (error) {
        console.error(error)
      }
    }

    const searchData = async params => {
      const taskList = reqCollectTaskList(params).then(res => {
        res.total = parseInt(res.total)
        res.size = parseInt(res.size)
        res.current = parseInt(res.current)
        res.records.map(item => {
          if (item.score <= 0.2) {
            item.color = 'orange'
          } else if (0.2 < item.score < 0.8) {
            item.color = 'blue'
          } else {
            item.color = 'green'
          }
          item.score = item.score && item.score * 100
        })
        return res
      })
      return taskList
    }

    const searchRobotData = async data => {
      state.queryRobot = data
      getRobotData()
    }

    const updatePage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      state.tableRef?.update()
    }

    const updateRobotPage = (page, size) => {
      state.page = page || 1
      state.size = size || 10
      getRobotData()
    }

    const addNew = () => {
      state.ifDetial = false
      state.robotDataList = []
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = ''
        state.detailform.isMatchProgramAccurately = -1
      }
      state.dialogFormVisible = true
      searchTaskTemplateList()
    }

    const searchTaskTemplateList = async () => {
      request('getCollectTaskTemplateList', {})
        .then(data => {
          const data1 = [{
            "templateType": 2,
            "isMatchProgramAccurately": -1,
            "minTimeInterval": null,
            "singleProgramRecordTime": null,
            "runTimesPerDay": null,
            "maxRecordTime": null,
            "templateName": "不使用",
            "programNameFilter": "",
            "runDays": '',
            "id": 'null',
            "canBeMultiTask": true,
            "filterList": []
          }]
          state.taskTemplateList = [...data1,...data]
        })
        .catch(error => {
          console.error(error)
        })
    }

    const onTemplateChange = (value) => {
      const taskTemplateDetail = state.taskTemplateList.filter(item=>item.id == value)[0]
      for (let key of Object.keys(state.detailform)) {
        if(key !== 'taskName'){
          state.detailform[key] = taskTemplateDetail[key]
        }
        state.detailform.taskTemplateId = taskTemplateDetail.id
        state.detailform.filterList = taskTemplateDetail.filterList
      }
      state.robotDataList = []
    }

    const editInfo = (item) => {
      state.ifDetial = true
      state.robotDataList = []
      for (let key of Object.keys(state.detailform)) {
        state.detailform[key] = item[key]
        // state.detailform.isMatchProgramAccurately = -1
      }
      state.dialogDetialVisible = true
      searchTaskTemplateList()
    }

    const deleteRobot = async row => {
      try {
        await ElMessageBox.confirm(t('activity.list.confirmDelete'), {
          confirmButtonText: t('activity.list.confirm1'),
          cancelButtonText: t('activity.list.cancel'),
          type: 'warning'
        })
        state.robotDataList = state.robotDataList.filter(item => {
          return item.robotId !== row.robotId
        })
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.packetreceive.deleteSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }

    const editSubmit = async () => {
      state.detailform.robotList = state.robotDataList.map(item => {
        item.cabinetSN = item.cabinetId
        item.robotSN = item.robotId
        return item
      })

      if(state.detailform.isMatchProgramAccurately == -1){
        state.detailform.singleProgramRecordTime = 0
      }
      try {
        state.detailformRef && (await state.detailformRef.validate())
        if( state.robotDataList.length == 0 ) {
          ElMessage({
            showClose: true,
            type: 'warning',
            message: t('collect.tasklist.addRobot')
          })
          return false
        }
        const url = 'requestCreateTask'
        if(state.detailform.taskTemplateId == 'null'){
          delete state.detailform.taskTemplateId
        }
        // state.detailform.taskTemplateId = state.detailform.taskTemplateId == 'null' ? null : state.detailform.taskTemplateId
        await request(url, state.detailform)
        state.dialogFormVisible = false
        state.tableRef?.update()
        ElMessage({
          showClose: true,
          type: 'success',
          message: t('activity.list.submitSuccess')
        })
      } catch (error) {
        console.error(error)
      }
    }

    const selectSubmit = () => {
      const robotDataList = [...state.robotDataList, ...state.multipleSelection]
      const nowData = []
      robotDataList.filter(row => {
        const isDuplicate = nowData.find(item => item.robotId == row.robotId)
        if (!isDuplicate) {
          nowData.push(row)
        }
      })
      state.robotDataList = nowData
      state.dialogTableVisible = false
      getTemplateByRobotNumberBatch(state.robotDataList)
    }

    const getTemplateByRobotNumberBatch = async (robotDataList) => {
      const serialNumberList = robotDataList.map(item => item.robotId);
      request('getTaskTemplateByRobotNumberBatch', {serialNumberList: serialNumberList, mainTaskTemplateId: state.detailform.taskTemplateId})
        .then(data => {
          state.parallelTaskTemplate = data
        })
        .catch(error => {
          console.error(error)
        })
    }

    const addRobot = () => {
      state.dialogTableVisible = true
      getRobotData()
    }

    const selectable = row => {
      if (row.healthTaskStatus == '执行中') {
        return false
      } else {
        return true
      }
    }
    const handleSelectionChange = val => {
      state.multipleSelection = val
    }

    // 提前终止任务
    const terminateTask = async row => {
      try {
        await request('requestTerminateTask', {
          isDelete: 1,
          robotSN: row.robotSN,
          taskId: row.taskId
        })
        state.tableRef?.update()
      } catch (error) {
        console.error(error)
      }
    }

    // 跳转报文管理
    const jumpReport = (row) => {
      router.push(`/${!state.standard ? 'collect' : 'error'}/messageList?taskName=${row.taskName}&robotSN=${row.robotSN}`)
      // this.$router.push({
      //   path: '/collect/messageList',
      //   query: { taskName: row.taskName }
      // })
    }

    const handleSizeChange = val => {
      state.size = val
      getRobotData()
    }

    const handleCurrentChange = val => {
      state.page = val
      getRobotData()
    }

    const onRealTimeChange = val => {
      if (val && state.duration) {
        state.timer = setInterval(() => {
          state.tableRef?.update()
        }, state.duration * 1000)
      } else {
        state.timer && clearInterval(state.timer)
      }
    }
    return {
      ...toRefs(state),
      handleSizeChange,
      handleCurrentChange,
      detailformRules,
      searchData,
      searchRobotData,
      updatePage,
      updateRobotPage,
      addNew,
      editInfo,
      deleteRobot,
      editSubmit,
      addRobot,
      handleSelectionChange,
      selectable,
      selectSubmit,
      terminateTask,
      jumpReport,
      onRealTimeChange,
      onTemplateChange
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  height: 100%;
  padding: 50px 10px 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
}
.el-icon-delete {
  cursor: pointer;
}
:v-deep(.el-progress-circle_track) {
  color: aquamarine;
}
</style>
